export default {
  sections: {
    order_summary: 'Total comandă',
  },
  labels: {
    add_items: 'Adaugă articole pentru a începe',
    item_count_one: '{{count}} articol',
    item_count_few: '{{count}} produse',
    item_count_other: '{{count}} articole',
  },
  buttons: {
    return: 'Înapoi la revizuirea comenzii',
  },
};
